import { render, staticRenderFns } from "./TabelaPrecos.vue?vue&type=template&id=d78b5a74&"
import script from "./TabelaPrecos.vue?vue&type=script&lang=js&"
export * from "./TabelaPrecos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports